import {createAsyncThunk} from "@reduxjs/toolkit";
import {IMonthDataBody} from "../rtk-api/reconciliations/types";
import {ReconciliationService} from "../../service/reconciliation/reconciliation.service";

export const fetchReconciliationExcelFile = createAsyncThunk<any, IMonthDataBody>(
    'reconciliation/excel',
    async function ({addressId, date}, {rejectWithValue}) {
        try {
            const response = await ReconciliationService.fetchReconciliationExcel({addressId, date})
            return response.data
        } catch (e) {
            return rejectWithValue(e)
        }
    }
)
